import { FormattedMessage } from 'react-intl';

import { ActionablePlaceholder } from 'ui-components/components/display-grid/actionable-placeholder';

import { messages } from './messages';

/**
 * Placeholder component shown when the suppliers grid is empty
 * Displays a message indicating there are no suppliers to view
 */
export const SuppliersGridPlaceholder = () => {
  return (
    <ActionablePlaceholder
      description={<FormattedMessage {...messages.gridPlaceholderDescription} />}
      title={
        <FormattedMessage
          {...messages.gridPlaceholderTitle}
          values={{
            b: (chunks) => <b>{chunks}</b>,
          }}
        />
      }
    />
  );
};
